async function logUserLocation(currency, price, productId) {
  try {
    // 1. Récupération de la localisation par IP
    const geoRes = await fetch('https://ipapi.co/json/');
    const geoData = await geoRes.json();

    // 2. Envoi immédiat à Supabase
    const supabaseUrl = 'https://rtcdllsnuompkbzlahxm.supabase.co/functions/v1/cart-creation-log';
    
    await fetch(supabaseUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      body: JSON.stringify({
        event_type: 'atc_tracking',
        product_id: productId,
        price: price,
        currency: currency,
        city: geoData.city,
        country: geoData.country_name,
        lat: geoData.latitude,
        lon: geoData.longitude,
        ip: geoData.ip
      })
    });

    console.log(`✅ Tracked: ATC in ${geoData.city}`);
  } catch (e) {
    console.log("Tracking failed but order continues");
  }
}